// HighLevel (LeadConnector) widget embeds — booking calendar + contact form.
// The embed script scans the page for its widgets and auto-sizes the iframes;
// on SPA remounts we remove + re-add it so it re-initializes fresh widgets.
export function loadHighLevelEmbed() {
  const existing = document.querySelector(
    'script[src="https://link.msgsndr.com/js/form_embed.js"]'
  );
  if (existing) existing.remove();
  const script = document.createElement("script");
  script.src = "https://link.msgsndr.com/js/form_embed.js";
  script.async = true;
  document.body.appendChild(script);
}